export const ChatsArray = [
    {
        name: "Billie",
        icon: "/Faceicons/face2.jpg",
        message: "You: oe ka ho?",
        date: "9:20"
    },
    {
        name: "Slash",
        icon: "/Faceicons/face3.jpg",
        message: "Lets go for jamming?",
        date: "5:55"
    },
    {
        name: "Kurt",
        icon: "/Faceicons/face4.jpg",
        message: "New ablum coming so..",
        date: "8:45"
    },
    {
        name: "SOAD",
        icon: "/Faceicons/face5.jpg",
        message: "You: Busy xu?",
        date: "7:16"
    },
    {
        name: "Sunil",
        icon: "/Faceicons/face6.jpg",
        message: "You: Dai kata?",
        date: "5:20"
    },
]